import icon from 'vue-svgicon';

icon.register({
    'regular/target-center-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="8.625" cy="15" r="3.75" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="8.625" cy="15" r="7.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.625 15l9-9M1.125 23.25l2.585-2.585M16.125 23.25l-2.585-2.585M19.693 8.175a1.5 1.5 0 0 1-1.273.425l-2.97-.424-.424-2.97a1.5 1.5 0 0 1 .424-1.273L18.632.75l.906 3.337 3.337.906z"/>`,
    },
});
